import React from 'react';
import { Select } from 'antd';
import { Form, Col, Row } from '@common/components';
import { RoleFlatType } from '@clinician-profile/graphql';
import { RoleSelect } from '@clinician-profile/components';

type RoleLevelType = {
  name: string;
  description: string;
};

export const RoleItem = ({
  disabled,
  roles,
  roleId,
  roleLevel = 'not_applicable',
  roleLevels,
  hasError = false,
}: {
  disabled: boolean;
  roles: RoleFlatType[];
  roleId?: string;
  roleLevel?: string;
  roleLevels: RoleLevelType[];
  hasError?: boolean;
}) => {
  const parsedRoleLevel = roleLevel === 'not_applicable' ? 'N/A' : roleLevel;

  const RoleItemHelpText = () => (
    <span>{`${parsedRoleLevel} used. Please change the level of this role.`}</span>
  );

  return (
    <Form.Item
      label="Role"
      colon={false}
      required
      rules={[{ required: true, message: 'Please select a role.' }]}
      validateStatus={hasError && !disabled ? 'error' : 'success'}
      help={roleId && hasError && !disabled && <RoleItemHelpText />}
    >
      <Row className="roleItemRow" gutter={8}>
        <Col className="roleColumn">
          <RoleSelect disabled={disabled} roles={roles} showLabel={false} />
        </Col>
        <Col className="levelColumn">
          <Form.Item
            name="roleLevel"
            validateTrigger={['onSubmit']}
            rules={[
              () => ({
                validator() {
                  if (hasError && !disabled) return Promise.reject('');
                  return Promise.resolve();
                },
              }),
            ]}
          >
            <Select
              disabled={disabled}
              placeholder="Level"
              size="large"
              getPopupContainer={(trigger) => trigger.parentNode}
            >
              {roleLevels.map(({ name, description }, i) => {
                return (
                  <Select.Option key={i} value={name}>
                    {description}
                  </Select.Option>
                );
              })}
            </Select>
          </Form.Item>
        </Col>
      </Row>
    </Form.Item>
  );
};
